  <div #testDiv id="trusted" class="trusted container comp">
    <h4>Trusted by our clients</h4>
    <p class="p2">
      Our 55k+ educational institutions rely on our platform to facilitate their
      ongoing daily operations and financing.
    </p>

    <div class="trustedImages container">
      <img src="../../../../assets/images/trusted/1.png" />
      <img src="../../../../assets/images/trusted/2.png" />
      <img src="../../../../assets/images/trusted/3.png" />
      <img src="../../../../assets/images/trusted/4.png" />
      <img src="../../../../assets/images/trusted/5.png" />
      <img src="../../../../assets/images/trusted/6.png" />

      <img src="../../../../assets/images/trusted/7.png" />
      <img src="../../../../assets/images/trusted/8.png" />
      <img src="../../../../assets/images/trusted/9.png" />
      <img src="../../../../assets/images/trusted/10.png" />
      <img src="../../../../assets/images/trusted/11.png" />
      <img src="../../../../assets/images/trusted/12.png" />
    </div>

  </div>
